import { Phone, Calendar } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CONTACT, waLink } from "@/constants/content";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 32 32" width="18" height="18" fill="currentColor" {...props}>
    <path d="M16 .5C7.4.5.5 7.4.5 16c0 3 .8 5.7 2.3 8.1L.6 31.5l7.6-2c2.3 1.3 5 2 7.8 2 8.6 0 15.5-6.9 15.5-15.5S24.6.5 16 .5Zm0 28.2c-2.5 0-4.9-.7-7-1.9l-.5-.3-4.5 1.2 1.2-4.4-.3-.5A12.7 12.7 0 0 1 3.3 16c0-7 5.7-12.7 12.7-12.7S28.7 9 28.7 16 23 28.7 16 28.7Zm7-9.5c-.4-.2-2.2-1.1-2.6-1.2-.3-.1-.6-.2-.8.2-.2.4-.9 1.2-1.2 1.4-.2.2-.4.3-.8.1-.4-.2-1.6-.6-3-1.9-1.1-1-1.9-2.2-2.1-2.6-.2-.4 0-.6.2-.8l.6-.7c.2-.2.3-.4.1-.8-.1-.3-1-2.4-1.3-3-.2-.4-.4-.4-.8-.4h-.6c-.3 0-.7.1-1 .5-.4.4-1.4 1.4-1.4 3.3 0 2 1.4 3.9 1.6 4.2.2.3 2.7 4.1 6.6 5.6 3.9 1.5 3.9 1 4.6.9.7-.1 2.2-.9 2.5-1.8.3-.9.3-1.6.2-1.8-.1-.2-.3-.3-.7-.5Z" />
  </svg>
);

export const TalkToSales = () => (
  <section id="talk-to-sales" className="cp-section cp-section--navy cp-talk-sales" data-testid="talk-to-sales-section">
    <div className="cp-container cp-talk-sales-inner">
      <Reveal>
        <span className="cp-eyebrow gold">Talk To Sales</span>
        <h2 className="cp-h2 light">Speak With Our Sales Team, Today</h2>
        <p className="cp-section-desc light">
          From unit selection to payment structuring — our team is one call away.
        </p>
      </Reveal>
      <Reveal delay={0.12} className="cp-talk-sales-ctas">
        <a href={`tel:${CONTACT.tel}`} className="btn btn-gold" data-testid="talk-sales-call-btn">
          <Phone size={16} /> Call Now
        </a>
        <a
          href={waLink("Hi, I'd like to talk to your sales team about Central Plaza SCO units.")}
          target="_blank"
          rel="noreferrer"
          className="btn btn-outline-light"
          data-testid="talk-sales-whatsapp-btn"
        >
          <WhatsAppIcon /> WhatsApp
        </a>
        <a
          href={waLink("Hi, I'd like to book a meeting to discuss Central Plaza SCO investment at Sector 10A, Kharkhoda.")}
          target="_blank"
          rel="noreferrer"
          className="btn btn-ghost-light"
          data-testid="talk-sales-book-meeting-btn"
        >
          <Calendar size={16} /> Book Meeting
        </a>
      </Reveal>
    </div>
  </section>
);
